/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Home",
  size: 20
}

const SvgHome = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M18.65 11.35L10 2.71l-8.65 8.64-.7-.7L10 1.29l9.35 9.36zM15 4h3v3h-1V5h-2z" />
    <path d="M3 11h1v7h3v-6h5v6h4v-7h1v8h-6v-6H8v6H3z" />
  </Svg>
)

SvgHome.defaultProps = defaultProps
export default SvgHome
